import { useQuery } from '@tanstack/react-query';
import { fetchProjectDropApi } from 'apis/common/commonApis';
import { IDropListProps } from 'utils/types/common';
/**
 * * 공통으로 쓰이는 쿼리 모음
 */

// 작품 리스트 - project_id, title만 출력
export const useProjectDropList = () => {
  const { status, data, error, isFetching } = useQuery(
    ['projectDropList'],
    async () => await fetchProjectDropApi(),
    {
      // enabled: !!projectId,
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.project_id,
            text: v.title,
          }),
        );
        newArr.push({ key: newArr?.length, value: -1, text: '연결 작품 없음' });
        return newArr;
      },
      onSuccess: (data) => {
        // console.log(data);
      },
    },
  );
  return { status, data, error, isFetching };
};
